<template>
  <AisInstantSearch
    :search-client="searchStore.getAlgoliaClient()"
    :index-name="productStore.productIndex"
    :insights="true"
    :future="{
      preserveSharedStateOnUnmount: true,
      persistHierarchicalRootCount: true,
    }"
    class="w-full"
  >
    <SearchWrapper />
  </AisInstantSearch>
</template>

<script setup lang="ts">
import SearchWrapper from '@/pages/HeaderPage/Partials/SearchWrapper.vue';
import { useAlgoliaProductStore } from '@/stores/Category/AlgoliaProductStore';
import { useAlgoliaSearchStore } from '@/stores/Category/AlgoliaSearchStore';

const productStore = useAlgoliaProductStore();
const searchStore = useAlgoliaSearchStore();
</script>
